


import { Component, Vue } from "vue-property-decorator";
import ServerRepository from "@/services/Server";
import { WPXFormValue } from "@/components/templates/WPXForm";
import UpdateServerForm from "@/services/Server/forms/UpdateServerForm";
import { AxiosError } from "axios";
import ServerTypeServicesAdditionDialog from "@/views/pages/server/ServerTypeServicesAdditionDialog.vue";

@Component({
  components: { ServerTypeServicesAdditionDialog },
  inject: [
    'serverRepository',
  ],
})
export default class CreateDepartment extends Vue {
  public readonly serverRepository!: ServerRepository;

  public loading: boolean = true;
  public serverTypes: string[] = [];
  public form: WPXFormValue<UpdateServerForm> = new WPXFormValue(UpdateServerForm);
  public serverStatus: string[] = ['Up', 'Down'];
  public servicesAdditionDialog: string = "";

  public async created(): Promise<void> {
    this.serverTypes = await this.serverRepository.getServerTypes();
    const server = await this.serverRepository.getServer(this.$route.params.server);
    this.form.data.hostname = server.hostname;
    this.form.data.type = server.type;
    this.form.data.config.ips = server.config?.ips;
    this.form.data.config.dns_ip = server.config?.dns_ip;
    this.form.data.status = server.status;
    await this.getServerTypeServices();
    this.form.data.services = server.services;
    this.loading = false;
  }

  public async getServerTypeServices(): Promise<void> {
    this.form.data.availableServices = await this.serverRepository.getServerTypeServices(this.form.data.type);
  }

  public async onServicesSelected(newServicesJson: string): Promise<void> {
    const selection = JSON.parse(newServicesJson) as string[];
    await this.addServerTypeServices(selection);
  }

  public async addServerTypeServices(newServices: string[]): Promise<void> {
    try {
      this.form.data.availableServices = await this.serverRepository.addServerTypeServices(this.form.data.type, { services: newServices });
    } catch (err) {
      this.handleError(err);
    }
  }

  public async editServer(): Promise<void> {
    try {
      await this.serverRepository.updateServerById(this.$route.params.server, {
        config: { ips: this.form.data.config.ips, dns_ip: this.form.data.config.dns_ip },
        hostname: this.form.data.hostname,
        services: this.form.data.services,
        status: this.form.data.status,
        type: this.form.data.type,
      });
      this.$successDialog.show(`Successfully updated server.`);
    } catch (e) {
      this.$errorDialog.show((e as AxiosError)?.response?.data.message || (e as Error).message)
    }
  }

  private handleError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }

  public async showServerTypeServicesAdditionDialog(): Promise<void> {
    this.servicesAdditionDialog = 'server-type-services-addition-dialog';
  }

  public async destroyDialog(): Promise<void> {
    this.servicesAdditionDialog = '';
  }

}
